import React from "react";
import "./ProjectCard.css";

function ProjectCard({ projectImage, title, description, projectLink }) {
	return (
		<div className="project__card">
			<div className="imgBox">
				<img src={projectImage} alt="project-img" />
			</div>

			<div className="content">
				<h3>{title}</h3>
				<p>{description}</p>
				<a href={projectLink}>View</a>
			</div>
		</div>
	);
}

export default ProjectCard;
